import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export function filterFalsy(): <T>(source: Observable<T>) => Observable<T> {
  return <T>(source: Observable<T>) => {
    return source.pipe(filter((value: any) => !!value));
  };
}
